import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { TotadminPermission } from 'data/__generated__';
import { EquipmentsList } from './components/EquipmentsList';

export const Equipments = () => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.equipments} />
                </HeaderTitle>
                <Link to={PAGES.equipmentCreate.url}>
                    <TotemPrimaryButton
                        data-test="create-equipment-button"
                        requiredPermissions={[TotadminPermission.EquipmentsManage]}
                    >
                        Créer un équipement
                    </TotemPrimaryButton>
                </Link>
            </Header>
            <Content>
                <ListContainer>
                    <EquipmentsList />
                </ListContainer>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.textColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
